import { InputGroup, InputLabel, Select } from '@components/Common';
import { FlowMeterType } from '@api/queries/tanks';
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

interface Props extends WithTranslation {
  isDisabled?: boolean;
  flowMeterType: FlowMeterType;
  onChange: (newValue: FlowMeterType) => void;
}

const FlowMeterTypeSelect = ({ isDisabled, onChange, flowMeterType, t }: Props) => {
  const options = [
    { value: FlowMeterType.None, label: t('tank.flow_meter_types.none') },
    { value: FlowMeterType.Normal, label: t('tank.flow_meter_types.normal') },
    { value: FlowMeterType.HydrogenPeroxide, label: t('tank.flow_meter_types.hydrogenperoxide') }
  ];

  const selectedOption = options.find(i => i.value === flowMeterType) || null;

  const selectedOptionChanged = (i, j) => {
    const flowMeterType = j.action === 'clear' ? null : i.value;
    onChange(flowMeterType);
  };

  return (
    <InputGroup>
      <InputLabel htmlFor="flowMeterType">{t('tank.flow_meter_type')}</InputLabel>
      <Select
        name="flowMeterType"
        isClearable={false}
        isDisabled={isDisabled}
        placeholder={t('tank.select_flow_meter_type')}
        value={selectedOption}
        onChange={selectedOptionChanged}
        options={options}
      />
    </InputGroup>
  );
};

export default withTranslation()(FlowMeterTypeSelect);
